export function getTweetStatusIdFromUrl(url) {
  const [, tweetId] = (url || '').match(/\/status\/(\d+)/) || [];

  return tweetId || null;
}

function escapeRegExp(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getTweetStatusUrlRegExp(tweetId) {
  return new RegExp(
    `(?:https?:\\/\\/)?(?:www\\.)?(?:twitter\\.com|x\\.com)\\/(?:[^\\s/]+\\/)*status\\/${escapeRegExp(
      tweetId,
    )}(?:\\?[^\\s)\\]}>"']*)?`,
    'g',
  );
}

function cleanTextAfterRemovingUrl(text, marker) {
  const markerRegExp = new RegExp(`[ \\t]*${escapeRegExp(marker)}[ \\t]*`, 'g');

  return text
    .replace(markerRegExp, (match, offset, value) => {
      const previousCharacter = value[offset - 1];
      const nextCharacter = value[offset + match.length];

      if (
        previousCharacter &&
        nextCharacter &&
        !/\s/.test(previousCharacter) &&
        !/\s/.test(nextCharacter)
      ) {
        return ' ';
      }

      return '';
    })
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function removeTweetUrl(text, tweetUrl) {
  const targetTweetId = getTweetStatusIdFromUrl(tweetUrl);

  if (!text || !tweetUrl) {
    return text || '';
  }

  const removedUrlMarker = `__removed_tweet_url_${Date.now()}__`;
  const textWithRemovedUrlMarker = targetTweetId
    ? text.replace(getTweetStatusUrlRegExp(targetTweetId), removedUrlMarker)
    : text.split(tweetUrl).join(removedUrlMarker);

  return cleanTextAfterRemovingUrl(textWithRemovedUrlMarker, removedUrlMarker);
}

function removeTwitterStatusUrl(text, tweetId) {
  return removeTweetUrl(text, `https://x.com/i/web/status/${tweetId}`);
}

export function removeQuoteTweetUrl(text, quoteTweetData) {
  if (!quoteTweetData) {
    return text || '';
  }

  return quoteTweetData.url
    ? removeTweetUrl(text, quoteTweetData.url)
    : removeTwitterStatusUrl(text, quoteTweetData.tweetId);
}
